import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { formatDateToISO, getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const EmailMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [id, setId] = useState("");

  const [email, setEmail] = useState("");

  const [emailInputs, setEmailInputs] = useState([""]);
  const [plantCode, setPlantCode] = useState("");
  const [weekChecked, setWeekChecked] = useState(false);
  const [monthChecked, setMonthChecked] = useState(false);
  const [yearChecked, setYearChecked] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [cNameTwo, setCNameTwo] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
    // fetchCompaniesNameTwo();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/SelectAllEmailMaster"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/master/getPlantCode");
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  //   const fetchCompaniesNameTwo = async () => {
  //     try {
  //       const response = await axios.post(
  //          BASE_URL+"/api/master/SelectAllDepartmentMaster"
  //       );
  //       if (response.data.success) {
  //         setCNameTwo(response.data.response);
  //       }
  //     } catch (error) {
  //       toast.error("Error fetching company data:", error);
  //     }
  //   };

  const handleEmailChange = (index, value) => {
    const newEmailInputs = [...emailInputs];
    newEmailInputs[index] = value;
    setEmailInputs(newEmailInputs);
  };

  const handleAddEmail = () => {
    setEmailInputs([...emailInputs, ""]);
  };

  const handleDeleteEmail = (index) => {
    const newEmailInputs = emailInputs.filter((_, i) => i !== index);
    setEmailInputs(newEmailInputs);
  };

  const onSubmit = async () => {
    const emailString = emailInputs.join(", ");
    if (plantCode === "") {
      toast.error("Please select Plant Code !");
      return;
    }
    if (emailString === "") {
      toast.error("Please Select Email ID !");
      return;
    }
    
    // console.log({
    //   plantCode,
    //   emails: emailString,
    //   week: weekChecked,
    //   month: monthChecked,
    //   year: yearChecked,
    // });
    const data = {
      PlantCode: plantCode,
      EmailID: emailString,
      weekLy: weekChecked,
      monthLy: monthChecked,
      yearLy: yearChecked,
      CreatedBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertEmailDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        // setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  };

  const onUpdate = async () => {
    const emailString = emailInputs.join(", ");

    if (id === "") {
      toast.error("Please Enter Email ID");
      return;
    }
    const data = {
      Id: id,
      PlantCode: plantCode,
      EmailID: emailString,
      weekLy: weekChecked,
      monthLy: monthChecked,
      yearLy: yearChecked,
      ModifyBy: getName().Name,
    };
    // console.log("Update data:", data);
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateEmailDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setPlantCode("");
    setEmail("");
    setEmailInputs([""]);
    setWeekChecked("");
    setMonthChecked("");
    setYearChecked("");
  };

  const handleAddNew = () => {
    setFormMode("add");
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowSelect = (company) => {
    setPlantCode(company.PlantCode);
    setEmailInputs(company.EmailID.split(", ")); // Split the EmailID string into an array
    setWeekChecked(company.Weekly === "true");
    setMonthChecked(company.Monthly === "true");
    setYearChecked(company.Yearly === "true");
    setId(company.ID);
    setFormMode("edit");
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Email Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Email Master (* Fields Are Mandatory)
            </Typography>

            {/* <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Plant Code (*)"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  {cName.map((company) => (
                    <MenuItem key={company.PlantCode} value={company.PlantCode}>
                      {company.PlantCode}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={3}>
              {emailInputs.map((email, index) => (
          <Grid container spacing={2} key={index} alignItems="center">
            <Grid item xs>
              <TextField
                label={`Email Address ${index + 1}`}
                fullWidth
                size="small"
                value={email}
                onChange={(e) => handleEmailChange(index, e.target.value)}
                margin="normal"
              />
            </Grid>
            <Grid item>
              <IconButton onClick={() => handleDeleteEmail(index)} color="secondary">
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button startIcon={<AddIcon />} onClick={handleAddEmail} variant="outlined" size="small">
          Add Email
        </Button>
            </Grid> */}

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Plant Code (*)"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  {cName.map((company) => (
                    <MenuItem key={company.PlantCode} value={company.PlantCode}>
                      {company.PlantCode}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                {emailInputs.map((email, index) => (
                  <Grid container spacing={2} key={index} alignItems="center">
                    <Grid item xs>
                      <TextField
                        label={`Email Address ${index + 1}`}
                        fullWidth
                        size="small"
                        value={email}
                        onChange={(e) =>
                          handleEmailChange(index, e.target.value)
                        }
                        margin="normal"
                        disabled={formMode === "initial"}
                      />
                    </Grid>
                    <Grid item>
                      <IconButton
                        onClick={() => handleDeleteEmail(index)}
                        color="secondary"
                        disabled={formMode === "initial"}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
                <Button
                  startIcon={<AddIcon />}
                  onClick={handleAddEmail}
                  variant="outlined"
                  size="small"
                  disabled={formMode === "initial"}
                >
                  Add Email
                </Button>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={weekChecked}
                      onChange={(e) => setWeekChecked(e.target.checked)}
                    />
                  }
                  label="Week"
                  disabled={formMode === "initial"}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={monthChecked}
                      onChange={(e) => setMonthChecked(e.target.checked)}
                    />
                  }
                  label="Month"
                  disabled={formMode === "initial"}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={yearChecked}
                      onChange={(e) => setYearChecked(e.target.checked)}
                    />
                  }
                  label="Year"
                  disabled={formMode === "initial"}
                />
              </Grid>
              {/* <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Submit
        </Button>
      </Grid> */}
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>
            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Plant Code</th>
                    <th>Email ID</th>
                    <th>Weekly</th>
                    <th>Monthly</th>
                    <th>Yearly</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.ID}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-label="Plant Code">{company.PlantCode}</td>
                      <td data-label="Email ID">{company.EmailID}</td>
                      <td data-label="Weekly">
                        {company.Weekly === "true" ? "Yes" : ""}
                      </td>
                      <td data-label="Monthly">
                        {company.Monthly === "true" ? "Yes" : ""}
                      </td>
                      <td data-label="Yearly">
                        {company.Yearly === "true" ? "Yes" : ""}
                      </td>
                      <td data-label="Created By">{company.CreatedBy}</td>
                      <td data-label="Created Date">
                        {formatDateToISO(company.CreatedDate)}
                        {/* {new Date(company.CreatedDate).toLocaleString()} */}
                      </td>
                      <td data-label="Modified By">{company.ModifyBy}</td>
                      <td data-label="Modified Date">
                        {company.ModifyDate
                          ? formatDateToISO(company.ModifyDate)
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default EmailMaster;
